'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactShare = require('react-share');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _constants = require('../../../constants');




var _SocialNetworkAuthentication = require('./SocialNetworkAuthentication.scss');var styles = _interopRequireWildcard(_SocialNetworkAuthentication);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
var
SocialNetworkAuthentication = function (_Component) {_inherits(SocialNetworkAuthentication, _Component);function SocialNetworkAuthentication() {var _temp, _this, _ret;_classCallCheck(this, SocialNetworkAuthentication);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.





    facebookAuthentication = function (response) {
      if (!response.error) {
        if (!response.email) {
          global.FB.api('/me?fields=name,email,picture', function (data) {
            // if (data.email) {
            data.id = data.id || data.userID || response.userID;
            var email = data.email || data.id + '@' + _constants.temporaryEmailEnding;
            _this.props.socialNetworkAuthentication({ network: _constants.socialNetworks.FACEBOOK, data: Object.assign({}, data, { email: email }) });
            // } else {
            //   console.error('Facebook profile does not have an email');
            // }
          });
        }
      } else {
        console.error(response.error);
      }
    }, _this.

    googleAuthentication = function (response) {
      if (response.code) {
        _this.props.socialNetworkAuthentication({
          network: _constants.socialNetworks.GOOGLE,
          data: { credential: response.code },
          config: { headers: { 'X-Requested-With': 'XMLHttpRequest' } } });

      } else {
        console.error(response.error);
      }
    }, _this.


    attemptFacebookLogin = function () {
      if (!global.FB) {
        console.error('Facebook SDK not loaded');
        return;
      }

      global.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          _this.facebookAuthentication(response.authResponse);
        } else {
          global.FB.login(function (loginResp) {
            if (loginResp.status === 'connected') {
              _this.facebookAuthentication(loginResp.authResponse);
            } else {
              console.error('Error while logging in', loginResp);
            }
          }, { scope: 'public_profile,email' });
        }
      });
    }, _this.

    attemptGoogleLogin = function () {
      if (!global.google || !global.google.accounts) {
        console.error('Google Auth SDK not loaded');
        return;
      }

      var client = global.google.accounts.oauth2.initCodeClient({
        client_id: _constants.googleSdkConfig.authClientId,
        scope: 'https://www.googleapis.com/auth/userinfo.email',
        ux_mode: 'popup',
        callback: _this.googleAuthentication });


      client.requestCode();
    }, _this.

    renderGoogleLogin = function () {return (
        _react2.default.createElement('div', { className: 'socialWrapper' },
          _react2.default.createElement('div', { onClick: !_this.props.isNewDesign && _this.attemptGoogleLogin, className: styles.socialIcon },
            _react2.default.createElement('span', { className: 'icon icon-google' },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }),
              _react2.default.createElement('span', { className: 'path4' })))));}, _this.





    renderFacebookLogin = function () {return (
        _react2.default.createElement('div', { className: 'socialWrapper' },
          _react2.default.createElement('div', { onClick: !_this.props.isNewDesign && _this.attemptFacebookLogin },
            _this.facebookIcon)));}, _this.




    renderOldDesign = function () {var _cx;return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(
            styles.social,
            _this.props.className, (_cx = {}, _cx[
            styles.pointerOnArea] = _this.props.clickOnArea, _cx)) },


          _react2.default.createElement('div', { className: 'socialTitle' }, _this.props.translate('socialConnection')),
          _this.renderFacebookLogin(),
          _this.renderGoogleLogin()));}, _this.



    renderNewDesign = function () {var _cx2;return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(
            styles.social,
            _this.props.className,
            styles.newSocial, (_cx2 = {}, _cx2[
            styles.pointerOnArea] = _this.props.clickOnArea, _cx2)) },


          _react2.default.createElement('div', {
              className: styles.socialWrap,
              onClick: _this.attemptFacebookLogin },

            _this.renderFacebookLogin(),
            _react2.default.createElement('p', { className: styles.socialTitle }, _this.props.translate('ConnectWithFacebook'))),

          _react2.default.createElement('div', {
              className: styles.socialWrap,
              onClick: _this.attemptGoogleLogin },

            _this.renderGoogleLogin(),
            _react2.default.createElement('p', { className: styles.socialTitle }, _this.props.translate('ConnectWithGoogle')))));}, _temp), _possibleConstructorReturn(_this, _ret);}SocialNetworkAuthentication.prototype.componentWillMount = function componentWillMount() {var FacebookIcon = (0, _reactShare.generateShareIcon)('facebook');this.facebookIcon = FacebookIcon({ round: true, size: this.props.size || 34, logoFillColor: 'white' });}; // Native implementation, no library
  // Native implementation, no library
  SocialNetworkAuthentication.prototype.


  render = function render() {
    return this.props.isNewDesign ? this.renderNewDesign() : this.renderOldDesign();
  };return SocialNetworkAuthentication;}(_react.Component);


SocialNetworkAuthentication.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  socialNetworkAuthentication: _propTypes2.default.func,
  className: _propTypes2.default.string,
  clickOnArea: _propTypes2.default.bool,
  isNewDesign: _propTypes2.default.bool,
  size: _propTypes2.default.number };exports.default =


SocialNetworkAuthentication;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/SocialNetworkAuthentication/SocialNetworkAuthentication.js
// module id = 384
// module chunks = 0